import axios from 'axios'
import { ModifierSurveyResults } from '../../models/modifierSurveyResults'
import { API_ROUTES } from '../routes'

export const getSurveyResults = async (customerId: string, year: number) => {
  return axios.get<ModifierSurveyResults>(
    API_ROUTES.CUSTOMER + `${customerId}/survey/${year}`
  )
}
